
(function () {
  'use strict';

  function zdarzenie(nazwa, dane) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nazwa, dane || {});
      }
    } catch (e) {}
  }

  var WZOR_EMAIL = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

  function bezOdstepow(v) { return v.replace(/[\s-]/g, ''); }

  function cyfryPolskie(v) {
    var m = /^(?:\+48|0048)?(\d{9})$/.exec(bezOdstepow(v));
    return m ? m[1] : null;
  }

  function telefonPoprawny(v) {
    if (cyfryPolskie(v)) return true;
    var s = bezOdstepow(v);
    return /^\+\d{8,15}$/.test(s) && s.indexOf('+48') !== 0;
  }

  function poprawne(pole) {
    if (pole.type === 'checkbox') return pole.checked || !pole.required;
    var v = pole.value.trim();
    if (!v) return !pole.required;
    return pole.getAttribute('data-bh-check') === 'tel' ? telefonPoprawny(v) : WZOR_EMAIL.test(v);
  }

  function komunikat(pole) {
    return document.getElementById(pole.id + '-zle');
  }

  function sprawdz(pole) {
    var ok = poprawne(pole);
    var blad = komunikat(pole);
    pole.setCustomValidity(ok ? '' : ((blad && blad.textContent.trim()) || pole.name));
    return ok;
  }

  function pokazBlad(pole, widoczny) {
    var blad = komunikat(pole);
    if (!blad) return;
    blad.hidden = !widoczny;
    var opis = (pole.getAttribute('aria-describedby') || '').split(' ').filter(function (t) {
      return t && t !== blad.id;
    });
    if (widoczny) {
      opis.push(blad.id);
      pole.setAttribute('aria-invalid', 'true');
    } else {
      pole.removeAttribute('aria-invalid');
    }
    if (opis.length) pole.setAttribute('aria-describedby', opis.join(' '));
    else pole.removeAttribute('aria-describedby');
  }

  function zapisPolski(pole) {
    if (pole.getAttribute('data-bh-check') !== 'tel') return;
    var c = cyfryPolskie(pole.value.trim());
    if (c) pole.value = '+48 ' + c.slice(0, 3) + ' ' + c.slice(3, 6) + ' ' + c.slice(6);
  }

  function przygotuj(formularz) {
    if (!formularz || formularz.hasAttribute('data-bh-check-ready')) return;
    formularz.setAttribute('data-bh-check-ready', '');
    var czekaFokus = false;
    var wcisniety = false;
    var odlozone = [];

    function pokazOdlozone() {
      wcisniety = false;
      window.setTimeout(function () {
        odlozone.splice(0).forEach(function (pole) {
          if (pole.value.trim()) pokazBlad(pole, !sprawdz(pole));
        });
      }, 0);
    }

    formularz.addEventListener('pointerdown', function () {
      wcisniety = true;
      window.addEventListener('pointerup', pokazOdlozone, { once: true });
      window.addEventListener('pointercancel', pokazOdlozone, { once: true });
    });

    formularz.addEventListener('input', function (ev) {
      var pole = ev.target;
      if (!pole.hasAttribute('data-bh-check')) return;
      if (sprawdz(pole)) pokazBlad(pole, false);
    });

    formularz.addEventListener('focusout', function (ev) {
      var pole = ev.target;
      if (!pole.hasAttribute('data-bh-check') || pole.type === 'checkbox') return;
      var ok = sprawdz(pole);
      if (ok) zapisPolski(pole);
      if (!pole.value.trim()) return;
      if (wcisniety && !ok) odlozone.push(pole);
      else pokazBlad(pole, !ok);
    });

    formularz.addEventListener('invalid', function (ev) {
      var pole = ev.target;
      if (!pole.hasAttribute('data-bh-check')) return;
      ev.preventDefault();
      pokazBlad(pole, true);
      if (czekaFokus) return;
      czekaFokus = true;
      window.setTimeout(function () {
        czekaFokus = false;
        var cel = formularz.querySelector(':invalid');
        if (cel && cel.hasAttribute('data-bh-check')) cel.focus();
      }, 0);
    }, true);

    formularz.addEventListener('submit', function () {
      [].forEach.call(formularz.querySelectorAll('[data-bh-check]'), zapisPolski);
    });

    [].forEach.call(formularz.querySelectorAll('[data-bh-check]'), sprawdz);
  }

  function przygotujWszystkie() {
    [].forEach.call(document.querySelectorAll('[data-bh-check]'), function (pole) {
      przygotuj(pole.form);
    });
  }

  function odslon() {
    var kotwica = (window.location.hash || '').replace('#', '');
    if (!kotwica) return;

    var alerty = document.querySelectorAll('[data-bh-form-alert]');
    for (var i = 0; i < alerty.length; i += 1) {
      if (alerty[i].getAttribute('data-bh-form-alert') !== kotwica) continue;
      alerty[i].hidden = false;

      for (var n = alerty[i].parentElement; n && n !== document.body; n = n.parentElement) {
        if (n.hidden) n.hidden = false;
      }

      if (window.BramoweHomeScroll) window.BramoweHomeScroll.doCelu(alerty[i]);
      else { alerty[i].focus(); alerty[i].scrollIntoView({ block: 'center' }); }
      zdarzenie('bramowe_home_form_posted', { formularz: kotwica });
    }
  }

  function start() {
    przygotujWszystkie();
    odslon();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);

  window.BramoweHomeForms = { odslon: odslon };
}());
